import React, { createContext, useState, useEffect, useContext, useCallback } from 'react';

const HelpCrunchContext = createContext();

export const HelpCrunchProvider = ({ children, accountData }) => {
  const [isHelpCrunchReady, setIsHelpCrunchReady] = useState(false);

  const removeHelpCrunch = useCallback(() => {
    setTimeout(() => {
      const script = document.querySelector(`script[src^="https://${window?.helpcrunchSettings?.organization}.widget.helpcrunch.com/"]`);
      if (script) {
        script.remove();
      }
      const chatTags = document.getElementsByClassName('helpcrunch-iframe-wrapper');
      if (chatTags) {
        const chatTagsArray = Array.from(chatTags);
        chatTagsArray.forEach((chatTag) => {
          chatTag.parentNode.removeChild(chatTag);
        });
      }
    }, 0);
  }, []);

  useEffect(() => {
    // HelpCrunch is disabled - remove any existing widgets
    removeHelpCrunch();

    // Clear any existing timeout when the effect runs
    // if (timeoutRef.current) {
    //   clearTimeout(timeoutRef.current);
    // }

    // HelpCrunch widget loading is commented out
    // timeoutRef.current = setTimeout(() => {
    //   let userData = undefined;
    //   if (accountData && accountData?.id) {
    //     userData = {
    //       user_id: accountData.id,
    //       name: accountData.full_name,
    //       email: accountData.email,
    //       phone: accountData.phone_number,
    //     };
    //   }

    //   // Define the HelpCrunch settings
    //   window.helpcrunchSettings = {
    //     organization: 'barbr',
    //     appId: '619a8f90-3723-441c-bd54-078fcf6d85bb',
    //     user: userData,
    //   };

    //   // Function to dynamically load the HelpCrunch widget
    //   (function (w, d) {
    //     var hS = w.helpcrunchSettings;
    //     if (!hS || !hS.organization) {
    //       return;
    //     }
    //     var widgetSrc = 'https://' + hS.organization + '.widget.helpcrunch.com/';
    //     w.HelpCrunch = function () {
    //       w.HelpCrunch.q.push(arguments);
    //     };
    //     w.HelpCrunch.q = [];
    //     w.HelpCrunch('onReady', () => {
    //       window?.HelpCrunch('closeChat');
    //       window?.HelpCrunch('hideChatWidget');
    //       setIsHelpCrunchReady(true);
    //     });
    //     function r() {
    //       if (d.querySelector('script[src="' + widgetSrc + '"]')) {
    //         return;
    //       }
    //       var s = d.createElement('script');
    //       s.async = 1;
    //       s.type = 'text/javascript';
    //       s.src = widgetSrc;
    //       (d.body || d.head).appendChild(s);
    //     }
    //     if (d.readyState === 'complete' || hS.loadImmediately) {
    //       r();
    //     } else if (w.attachEvent) {
    //       w.attachEvent('onload', r);
    //     } else {
    //       w.addEventListener('load', r, false);
    //     }
    //   })(window, document);
    // }, 4500);

    // Cleanup function to clear timeout and remove the script when the component unmounts or dependencies change
    return () => {
      // if (timeoutRef.current) {
      //   clearTimeout(timeoutRef.current);
      //   timeoutRef.current = null;
      // }
      setIsHelpCrunchReady(false);
      removeHelpCrunch();
    };
  }, [accountData, removeHelpCrunch]);

  return <HelpCrunchContext.Provider value={{ isHelpCrunchReady }}>{children}</HelpCrunchContext.Provider>;
};

export const useHelpCrunch = () => useContext(HelpCrunchContext);
